import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { isPhoneViewport } from "./utils/viewport";
import "./asset/stylesheet/base.css";

const rootContainer = document.getElementById("app");
console.log("夕航科技官网");

const app = (
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// 页头页脚会按断点渲染不同的 DOM，所以静态页固定记录渲染时用的断点。
// breakpointMatches 为真时直接水合复用静态 DOM（首屏不闪、styled-components 复用服务端样式）；
// 对不上（手机版访问桌面版静态页、带 query 的链接等）就清空容器重新渲染，保证不会出现内容重复。
const currentBreakpoint = isPhoneViewport(
  window.innerWidth,
  window.innerHeight
)
  ? "phone"
  : "desktop";

const prerenderPathname = rootContainer.getAttribute("data-prerender-pathname");
const prerenderBreakpoint = rootContainer.getAttribute(
  "data-prerender-breakpoint"
);

const canHydrate =
  Boolean(prerenderPathname) &&
  prerenderPathname === window.location.pathname &&
  prerenderBreakpoint === currentBreakpoint &&
  !window.location.search &&
  rootContainer.childElementCount > 0;

if (canHydrate) {
  hydrateRoot(rootContainer, app);
} else {
  rootContainer.innerHTML = "";
  createRoot(rootContainer).render(app);
}
